export default __webpack_public_path__ + "55afbdb9c87d949319ca373cbe0ad85b.svg";